/**
 * useWorkItemOpener — Open any work item from anywhere in the portal.
 *
 * @example
 * ```tsx
 * import { useWorkItemOpener } from '@/hooks/useWorkItemOpener';
 *
 * function MyComponent() {
 *   const { openWorkItem, openWorkItemByNumber, getPermalink } = useWorkItemOpener();
 *
 *   // Open by UUID
 *   openWorkItem('550e8400-e29b-41d4-a716-446655440000');
 *
 *   // Open by item number
 *   openWorkItemByNumber('JOB-0042');
 *
 *   // Open a pre-loaded work item directly (no API call)
 *   openWorkItemDirect(workItemObject);
 *
 *   // Generate a sharable permalink
 *   const link = getPermalink('JOB-0042');
 *   // → "https://dev-next.totalaccess.co.za/client-zone/dashboard?wi=JOB-0042"
 * }
 * ```
 */

export {
  useWorkItemOpener,
  useOptionalWorkItemOpener,
  dispatchOpenWorkItem,
  generateWorkItemPermalink,
} from '@/contexts/WorkItemOpenerContext';

export type { WorkItemOpenerOptions } from '@/contexts/WorkItemOpenerContext';
